import { memo } from 'react';

import { useMe } from 'com/App/WithMe';
import { TEditorConfig } from 'com/Editor/Editor/interface';
import { EXERCISE_LABELS } from 'core/helpers/deck';
import { LANGUAGES, LANGUAGES_DATA } from 'core/helpers/languages';
import { FormCheckbox, FormGroup, FormInput, FormSelect } from 'core/ui/Form';

const DeckEditorForm: TEditorConfig<null, TDeck, TDeckUpdate>['Form'] = ({
  editingEntity: editingDeck,
  onChange,
}) => {
  const me = useMe();

  return (
    <>
      <FormGroup title="Definition">
        <FormInput
          placeholder="Name"
          name="name"
          value={editingDeck.name}
          onChange={onChange}
        />
        {me?.isAdmin && (
          <FormInput
            placeholder="UID"
            name="uid"
            value={editingDeck.uid}
            onChange={onChange}
          />
        )}
        <FormSelect
          name="lang"
          onChange={onChange}
          value={editingDeck.lang ?? 'null'}
        >
          <option value="null">None</option>
          {LANGUAGES.map(lang => (
            <option key={lang} value={lang}>
              {LANGUAGES_DATA[lang].nativeName} (
              {LANGUAGES_DATA[lang].localizedName})
            </option>
          ))}
        </FormSelect>
      </FormGroup>
      <FormGroup title="Definition languages">
        {(['none', ...Object.values(TLang)] as const).map(lang => (
          <FormCheckbox
            key={lang}
            name={`definitionLangs.${lang}`}
            onChange={onChange}
            label={
              lang === 'none' ? 'None' : LANGUAGES_DATA[lang].localizedName
            }
            checked={editingDeck.definitionLangs.includes(lang)}
          />
        ))}
      </FormGroup>
      <FormGroup title="Exercises">
        {Object.values(TExercise).map(exercise => (
          <FormCheckbox
            key={exercise}
            name={`exercises.${exercise}`}
            onChange={onChange}
            label={EXERCISE_LABELS[exercise]}
            checked={editingDeck.exercises.includes(exercise)}
          />
        ))}
      </FormGroup>
    </>
  );
};

export default memo(DeckEditorForm);
